<div class="help-dialog">
  <div class="help-dialog-header d-flex align-items-center justify-content-between">
    <div class="help-title">Live Connection:</div>
    <button type="button" class="btn btn-link p-0 text-decoration-none" (click)="close()" aria-label="Close">
      <span class="material-icons">close</span>
    </button>
  </div>

  <div class="help-dialog-body">
    <div class="text-muted">
      Showing all RTK base stations and RTK rovers that are currently connected to our NTRIP Caster service.
    </div>
  </div>
</div>


